import './sponsors.css'
import React from 'react'

export default function Ask() {
    return(
        <div>
            {/* <!-- Start Discount --> */}
            <div className="discount" id="discount">
            <div className="image">
                <div className="content">
                <h2>Sponsor Us</h2>
                <p>
                Nakshatra has always aimed to promote the ideas of 
                mathematics and astronomy among our peers all the while 
                being the hub for enthusiasts willing to explore and 
                further their interests. We are open to sponsorship to 
                help achieve our goals and would love for you to 
                collaborate with us for our upcoming events and a few 
                other secret projects along the way. Rest assured, 
                Nakshatra's outreach and event footfall will be sure to benifit you- 
                our PR team is just a call away.
                </p>
                <img src="imgs/discount.png" alt="" />
                </div>
            </div>
            <div className="form">
                <div className="content">
                <h2>Tell us about yourselves!</h2>
                <form action="">
                    <input className="input" type="text" placeholder="Your Name" name="name" />
                    <input className="input" type="email" placeholder="Your Email" name="email" />
                    <input className="input" type="text" placeholder="Your Phone" name="mobile" />
                    <textarea className="input" placeholder="Tell Us About Your Needs" name="message"></textarea>
                    <input type="submit" value="Send" />
                </form>
                </div>
            </div>
            </div>
            {/* <!-- End Discount --> */}
        </div>
    )
}